import React from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import SectionSeparator from "components/sectionSeparator";

export const query = graphql`
    fragment hero on Language {
        hero {
            heading
            subheading
            background
            description
            ctaText
            ctaUrl
            imageAlt
            image {
                childImageSharp {
                    fluid(maxWidth: 890, quality: 85) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }
    }
`;

const Hero = ({ data }) => {
    return (
        <section
            className={`hero container section mx-auto bg${data.background}`}
        >
            <div className="hero__tagline">
                <div className="hero__tagline-content-wrap">
                    <SectionSeparator />
                    <p className="hero__tagline-subtitle">{data.subheading}</p>
                    <h2
                        className="hero__tagline-title"
                        dangerouslySetInnerHTML={{ __html: data.heading }}
                    />
                    <p className="hero__tagline-text">{data.description}</p>
                    <a href={data.ctaUrl}>
                        <button className="btn btn--primary mt-8">
                            {data.ctaText}
                        </button>
                    </a>
                </div>
            </div>
            <div className="hero__image">
                <Img
                    fluid={data.image.childImageSharp.fluid}
                    className="mx-auto"
                    alt={data.imageAlt}
                    loading="eager"
                    fadeIn={false}
                    critical={true}
                    data-sal="slide-right"
                    data-sal-delay="400"
                    data-sal-duration="500"
                />
            </div>
        </section>
    );
};

export default Hero;
